import { ReactElement } from 'react'
import { StudentTestCard, SectionTitle, Loader } from '../../../../components'
import { TestWrapper, TestListWrapper } from '../subcomponents'
import strings from '../../../../locale/en'
import { TestType } from '../../../../const/type'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { updateTestStatus } from '../../../../redux/test/action'
import { determineTestStatus, canTakeTest } from './helpers'
import { ScheduledTestsProps } from '../typings'

const ScheduledTests = ({
  scheduledTests,
  isPractice
}: ScheduledTestsProps): ReactElement => {
  const {
    isLoading,
    studentId = '',
    selectedBatch = ''
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.test.isScheduledTestsLoading,
      studentId: state.user?.userInfo?.userDetail?.usersId,
      selectedBatch: state.user.selectedBatch
    }),
    shallowEqual
  )
  const history = useHistory()
  const dispatch = useDispatch()

  return (
    <TestWrapper isPractice={isPractice}>
      {!isPractice && (
        <SectionTitle title={strings.assessment.scheduledTests} />
      )}
      {isLoading ? (
        <Loader />
      ) : (
        <TestListWrapper>
          {scheduledTests?.map((test, index) => {
            const status = determineTestStatus(test.testStatus)
            const {
              testPaperVo: { name, duration, questionCount },
              publishDateTime
            } = test

            return (
              <StudentTestCard
                testType={TestType.SCHEDULED}
                name={name}
                duration={duration}
                publishDateTime={publishDateTime}
                questionCount={questionCount}
                key={`scheduled-test-${index}`}
                onSelect={() => {
                  dispatch(
                    updateTestStatus({
                      batchId: selectedBatch,
                      studentId: studentId,
                      testPaperId: test?.testPaperId,
                      status: test?.testStatus
                    })
                  )

                  if (canTakeTest(test?.testStatus)) {
                    history.push(ROUTES.TESTINSTRUCTIONS)
                  }
                }}
                status={status}
                disabled={status === strings.test.pending}
              />
            )
          })}
        </TestListWrapper>
      )}
    </TestWrapper>
  )
}

export default ScheduledTests
